exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.clicker:hover {\n\tcursor: pointer;\n\tbackground-color:rgba(0,0,0,0.2);\n}\n", ""]);

// exports
